module.exports = __webpack_public_path__ + "ef06c38d6b0d73ce3f7868b5f922e3b4.jpg";